document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.sfaq__item').forEach(function (item) {
    var question = item.querySelector('.sfaq__question');
    var answer = item.querySelector('.sfaq__answer');

    question.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');

      item.parentElement.querySelectorAll('.sfaq__item').forEach(function (other) {
        other.classList.remove('is-open');
        other.querySelector('.sfaq__question').setAttribute('aria-expanded', 'false');
        other.querySelector('.sfaq__answer').style.maxHeight = null;
      });

      if (!isOpen) {
        item.classList.add('is-open');
        question.setAttribute('aria-expanded', 'true');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });
});
